module.exports = __webpack_public_path__ + "static/media/AssetVault_logo.28994f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/views/assets/global/img/AssetVault_logo.jpg
// module id = 1541
// module chunks = 0